import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {DashboardService} from '../dashboard.service';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {Location} from '@angular/common';

@Component({
    selector: 'app-create-rating-categories',
    templateUrl: './create-rating-categories.component.html',
    styleUrls: ['./create-rating-categories.component.css'],
    standalone: false
})

export class CreateRatingCategoriesComponent implements OnInit {
  isCategoryCreated = false;
  createdCategory: any;
  selectedCategory = '';
  uploading = false;
  rateCategory = {
    category: [],
    name: '',
    title: '',
    description: '',
    popular_index: '1',
    RatingPositiveNegativeCriteriaType: 'secularism_index', // 'secularism_index', 'bhakt_index'
    RatingPositiveNegativePercent: '',
    type: 1,
    entity: '',
    icon: ''
  };
  icons: any[] = ['', '', ''];
  ratingParameters: any[] = [
    {
      category: [],
      ratingCategory: '',
      fieldName: '',
      icon: '',
      description: ''
    },
    {
      category: [],
      ratingCategory: '',
      fieldName: '',
      icon: '',
      description: ''
    },
    {
      category: [],
      ratingCategory: '',
      fieldName: '',
      icon: '',
      description: ''
    },
  ];
  message: string;
  categories: any[] = [];
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: 'auto',
    minHeight: '10rem',
    minWidth: '70rem',
    enableToolbar: true,
    showToolbar: true,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['undo',
        'redo', 'strikeThrough',
        'subscript',
        'superscript', 'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
      ],
      ['fontSize', 'customClasses',
        'removeFormat',
        'textColor',
        'backgroundColor',
        'unlink',
        'insertVideo']
    ]
  };
  categorizedEntities = [];

  loading = false;

  constructor(
    private api: DashboardService,
    private toastr: ToastrService,
    private locationService: Location
  ) {
  }

  ngOnInit(): void {
    this.getAllCategories();
  }

  createRatingCategory(): void {
    if (this.rateCategory.category.length) {
      const payload = {...this.rateCategory};
      if (payload.RatingPositiveNegativeCriteriaType !== 'bhakt_index') {
        // @ts-ignore
        payload.RatingPositiveNegativePercent = 0;
      }
      this.loading = true;
      this.api.createRateCategory(payload).subscribe((data) => {
        this.createdCategory = data.response;
        this.ratingParameters.forEach((e, i) => {
          Object.assign(this.ratingParameters[i], {
            category: this.createdCategory.category,
            ratingCategory: this.createdCategory.id
          });
        });
        this.message = `New Category ${this.createdCategory.name} Created`;
        this.toastr.success(this.message, 'Success');
        this.isCategoryCreated = true;
        this.loading = false;
      }, err => {
        this.toastr.error(err.error.message);
        this.loading = false;
      });
    } else {
      this.toastr.error('Please select at least one category.');
    }
  }

  getAllCategories(): void {
    this.api.getAllCategories('').subscribe((data) => {
      this.categories = data?.categories || [];
      if (!this.categories.length) {
        this.selectedCategory = '';
        this.categorizedEntities = [];
        this.rateCategory.entity = '';
        return;
      }
      this.selectedCategory = this.categories[0].id;
      this.getEntitiesByCategory();
    });
  }

  getEntitiesByCategory(): void {
    this.api.getEntitiesByCategory(this.selectedCategory).subscribe(res => {
      this.categorizedEntities = Array.isArray(res) ? res : [];
      this.rateCategory.entity = this.categorizedEntities?.[0]?.id || '';
    });
  }

  createRatingParameters(): void {
    this.api.createRatingParameters({parameters: this.ratingParameters}).subscribe((data) => {
      this.message = `New rating Parameters added`;
      this.toastr.success(this.message, 'Success');
      this.goBack();
    }, err => this.toastr.error(err.error.message));
  }

  onParamChange(event, i): void {
    this.ratingParameters[i].fieldName = event;
  }

  onDescriptionChange(event, i): void {
    this.ratingParameters[i].description = event;
  }

  // pickIcon(event, index): void {
  //   const fileList: FileList = event.target.files;
  //   if (fileList.length > 0) {
  //     const file: File = fileList[0];
  //     this.api.uploadFile('/icon', file).subscribe((data) => {
  //       this.ratingParameters[index].icon = data.url;
  //     });
  //   }
  // }

  pickIcon(event, index): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        this.ratingParameters[index].icon = res.response.url;
      });
    };
  }

  uploadImage(event): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.uploading = true;
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        this.rateCategory.icon = res.response.url;
        this.uploading = false;
      }, err => {
        this.toastr.error(err.error.message);
        this.uploading = false;
      });
    };
  }

  goBack = (): void => this.locationService.back();

  catChange(e, id): void {
    if (e.target.checked) {
      this.rateCategory.category.push(id);
    } else {
      this.rateCategory.category.splice(this.rateCategory.category.indexOf(id), 1);
    }
  }

  submitForm(): void {
    const ele = document.getElementById('form_submit');
    if (!!ele) {
      ele.click();
    }
  }
}
